import React from 'react';

const SvgArrow = ({ color = "currentColor", strokeWidth = 2, size = 32 }) => {
  const lineLength = size * 0.5;
  const arrowHeadWidth = strokeWidth * 2;
  const arrowLength = size * 0.5;
  const p1_x = lineLength - arrowHeadWidth;
  const p1_y = size * 0.35; 
  
  const p2_x = lineLength;
  const p2_y = size / 2;

  const p3_x = lineLength - arrowHeadWidth;
  const p3_y = size * 0.65;

  return (
    <div className={`w-${size / 4} h-${size / 4} rotate-[-90deg]`} style={{ width: size, height: size }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 30 30`}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="0" y1={size / 2} x2={arrowLength} y2={size / 2} />

        <polyline 
          points={`${p1_x} ${p1_y}, ${p2_x} ${p2_y}, ${p3_x} ${p3_y}`} 
        />
      </svg>
    </div>
  );
};

export default SvgArrow;